const opsAccountMap = new Map([
  ['list', '/systemAccount/list'],
  ['add', '/systemAccount/create'],
  ['remove', '/systemAccount/delete'],
  ['search', '/employee/search']
]);

export default opsAccountMap;
